import React, { useMemo } from 'react';
import cx from 'classnames';

import Table from 'app/components/ui/Table';
import s from 'app/components/ui/Table/Table.module.sass';
import TokenName from 'app/components/ui/Table/components/TokenName';
import { PairInformationDataType } from 'app/types/table';
import { getSlice } from 'app/utils/helpers';

type PairInformationProps = {
  data: PairInformationDataType[]
  loading: boolean
};

const PairInformationTable: React.FC<PairInformationProps> = ({
  data,
  loading,
}) => {
  const columns = useMemo(() => [
    {
      Header: 'Pair name',
      id: 'pairs',
      accessor: (row: any) => (
        <div
          className={cx(s.cell)}
        >
          <TokenName
            firstTokenImage={row.token1Logo}
            secondTokenImage={row.token2Logo}
            name={`${row.token1Name} / ${row.token2Name}`}
            tokensNames={{
              firstTokenName: row.token2Name,
              secondTokenName: row.token2Name,
            }}
            version={row.version}
          />
        </div>
      ),
    },
    {
      Header: 'Pair address',
      accessor: 'pairAddress',
    },
    {
      Header: 'XTZ address',
      accessor: 'token1Address',
    },
    {
      Header: (row: any) => (
        <div
          className={cx(s.cell)}
        >
          {`${getSlice(row.data[0].token2Name)} address`}
        </div>
      ),
      accessor: 'token2Address',
    },
  ], []);

  return (
    <Table
      columns={columns}
      data={data}
      theme="primary"
      loading={loading}
      pageCount={1}
    />
  );
};

export default PairInformationTable;
